__turbopack_context__.v({
  "dropdown": "HZe63q_dropdown",
  "item": "HZe63q_item",
});
